import axios from 'axios';
import authService from './authService';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

/**
 * Dev Tools Service
 * Handles dev tools related API calls
 */
const devToolsService = {
    /**
     * Verify website password for dev access
     * @param {string} password - The password to verify
     * @returns {Promise} API response with access_granted status
     */
    verifyWebsitePassword: async (password) => {
        try {
            const response = await axios.post(
                `${API_URL}/api/v1/devtools/verify-website-password`,
                { password },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            return {
                success: response.data.success || false,
                accessGranted: response.data.access_granted || false,
                message: response.data.message || 'Password verification completed'
            };
        } catch (error) {
            // Handle error responses from API
            if (error.response) {
                const errorData = error.response.data;
                
                return {
                    success: false,
                    accessGranted: false,
                    message: errorData.message || 'Incorrect password',
                    status: error.response.status
                };
            }

            // Handle network errors
            return {
                success: false,
                accessGranted: false,
                message: 'Network error. Please check your connection.',
                status: null
            };
        }
    },

    /**
     * Advance test clock for a subscription
     * @param {string} sport - The sport of the subscription (e.g., 'NBA', 'AFL')
     * @param {number} advanceByDays - Number of days to advance (max 30)
     * @returns {Promise} API response with test clock data
     */
    advanceTestClock: async (sport, advanceByDays) => {
        try {
            const token = authService.getToken();
            
            if (!token) {
                return {
                    success: false,
                    message: 'Authentication required to advance test clock',
                    status: 401
                };
            }

            const response = await axios.post(
                `${API_URL}/api/v1/devtools/advance-test-clock`,
                { 
                    sport,
                    advance_by_days: advanceByDays
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            return {
                success: response.data.success || false,
                message: response.data.message || 'Test clock advanced successfully',
                data: response.data.data || null,
                simulatedTime: response.data.simulated_time || null,
                realTime: response.data.real_time || null,
                timeDifference: response.data.time_difference || null
            };
        } catch (error) {
            // Handle error responses from API
            if (error.response) {
                const errorData = error.response.data;
                
                return {
                    success: false,
                    message: errorData.message || 'Failed to advance test clock',
                    hint: errorData.hint || null,
                    status: error.response.status
                };
            }

            // Handle network errors
            return {
                success: false,
                message: 'Network error. Please check your connection.',
                status: null
            };
        }
    }
};

export default devToolsService;

